import { Mobile } from "@govlaunch/core";
import PropTypes from "prop-types";
import * as queryString from "query-string";
import React from "react";

export default function Airtable({ block }) {
  const blockData = block.getData();

  const embedUrl = blockData.get("src");
  const width = blockData.get("width");
  const height = blockData.get("height");
  const parsed = queryString.parseUrl(embedUrl);

  return (
    <Mobile>
      {isMobile => {
        const embedQuery = queryString.stringify({
          ...parsed.query,
          layout: isMobile ? "card" : undefined,
        });

        return (
          <div
            css={{
              border: "1px solid #ccc",
              borderRadius: 4,
              overflow: "hidden",
              marginTop: 10,
            }}
          >
            <iframe
              src={`${parsed.url}?${embedQuery}`}
              frameBorder="0"
              css={{
                width: "100%",
              }}
              style={{
                width,
                height,
              }}
            />
          </div>
        );
      }}
    </Mobile>
  );
}

Airtable.propTypes = {
  block: PropTypes.object.isRequired,
};
